const pick = (obj: Record<string, unknown>, keys: string[]) =>
  keys.reduce((result, key) => {
    if (key in obj) {
      return { ...result, [key]: obj[key] };
    }
    return result;
  }, {});

export default pick;
